/*
 * Module for the Insurance edit view
*/
rs.module("content/system/configuration/availablepaycomponent/add",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, codeValues) {
            var payComponentTabForm = $.js(jsSelectors.payComponentTabForm);

            var typeSelector = payComponentTabForm.js(jsSelectors.typeSelector);
            var reducePaymentByVoidsCheckbox = payComponentTabForm.js(jsSelectors.reducePaymentByVoidsCheckbox);
            var individualVendorsCheckbox = payComponentTabForm.js(jsSelectors.individualVendorsCheckbox);

            var vendorSelector = payComponentTabForm.js(jsSelectors.vendorSelector);
            var vendorSelectHelper = selectHelper.getHelper(vendorSelector);
            var adjustmentCategorySelector = payComponentTabForm.js(jsSelectors.adjustmentCategorySelector);
            var adjustmentCategorySelectHelper = selectHelper.getHelper(adjustmentCategorySelector);

            var payComponentMethodSelect = payComponentTabForm.js(jsSelectors.payComponentMethodSelect);
            var rateAmount = payComponentTabForm.js(jsSelectors.rateAmount);
            var ratePercent = payComponentTabForm.js(jsSelectors.ratePercent);

            var perPayLimit = payComponentTabForm.js(jsSelectors.perPayLimit);
            var annualLimit = payComponentTabForm.js(jsSelectors.annualLimit);
            var lifetimeLimit = payComponentTabForm.js(jsSelectors.lifetimeLimit);

            // enable/disable controls when type is changed
            typeSelector.change(function () {
                var isAdjustment = typeSelector.val() == codeValues.adjustmentCode;
                adjustmentCategorySelectHelper.setDisabled(!isAdjustment);

                if (!isAdjustment) {
                    adjustmentCategorySelectHelper.setValue(null);
                }

                var isDeduction = typeSelector.val() == codeValues.deductionCode;
                reducePaymentByVoidsCheckbox.prop('disabled', !isDeduction);
                individualVendorsCheckbox.prop('disabled', !isDeduction);
                vendorSelectHelper.setDisabled(!isDeduction || individualVendorsCheckbox[0].checked);

                if (!isDeduction) {
                    reducePaymentByVoidsCheckbox[0].checked = false;
                    individualVendorsCheckbox[0].checked = false;
                    vendorSelectHelper.setValue(null);
                }

                if (individualVendorsCheckbox[0].checked) {
                    vendorSelectHelper.setValue(null);
                }
            });

            // enable/disable vendor selector when individual vendor checkbox is changed
            individualVendorsCheckbox.change(function () {
                vendorSelectHelper.setDisabled(this.checked);

                if (this.checked) {
                    vendorSelectHelper.setValue(null);
                }
            });

            //enable/disable controls when method is changed
            payComponentMethodSelect.change(function () {
                var methodIsStandard = payComponentMethodSelect.val() == codeValues.standardCode;
                perPayLimit.prop('disabled', !methodIsStandard);
                annualLimit.prop('disabled', !methodIsStandard);
                lifetimeLimit.prop('disabled', !methodIsStandard);

                if (!methodIsStandard) {
                    perPayLimit.val(null);
                    annualLimit.val(null);
                    lifetimeLimit.val(null);
                }

                enableRatePercent();
            });
                        
            adjustmentCategorySelector.change(enableRatePercent);

            //enable/disable rate percent 
            function enableRatePercent() {
                var methodIsStandard = payComponentMethodSelect.val() == codeValues.standardCode;
                var categoryIsCola = adjustmentCategorySelector.val() == codeValues.colaCode;
                rateAmount.prop('disabled', !methodIsStandard && !categoryIsCola);
                ratePercent.prop('disabled', !methodIsStandard && !categoryIsCola);

                if (!methodIsStandard && !categoryIsCola) {
                    rateAmount.val(null);
                    ratePercent.val(null);
                }
            }

            // enable/disable rate amount when rate percent is changed
            ratePercent.change(function () {
                rateAmount.prop('disabled', ratePercent.val());

                if (ratePercent.val()) {
                    rateAmount.val(null);
                }
            });

            // enable/disable rate percent when rate amount is changed
            rateAmount.change(function () {
                ratePercent.prop('disabled', rateAmount.val());

                if (rateAmount.val()) {
                    ratePercent.val(null);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);